import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api } from '../lib/api';

const STATUSES = ['Registration Received', 'Payment Pending', 'Payment Verified', 'Invitation Pending', 'Invitation Sent', 'Learner Joined', 'Onboarding Complete'];

const AdminOnboarding = () => {
  const [rows, setRows] = useState([]);
  const load = async () => {
    const r = await api.get('/admin/onboarding');
    setRows(r.data.items || []);
  };
  useEffect(() => { load(); }, []);

  const advance = async (id, status) => {
    await api.patch(`/admin/onboarding/${id}`, { status });
    await load();
  };

  return (
    <AdminShell title="Classroom onboarding">
      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto" data-testid="onboarding-table">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F5F2] text-left"><tr>
            <th className="px-4 py-3 font-semibold">Learner</th><th className="px-4 py-3 font-semibold">Subject</th><th className="px-4 py-3 font-semibold">Status</th><th className="px-4 py-3 font-semibold">Action</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-black/5" data-testid={`onboarding-row-${r.id}`}>
                <td className="px-4 py-3 text-xs text-[#4B5563]">{r.learner_id.slice(0,8)}…</td>
                <td className="px-4 py-3">{r.subject}</td>
                <td className="px-4 py-3"><span className="text-xs font-semibold px-2 py-1 rounded-full bg-[#F3F5F2]">{r.status}</span></td>
                <td className="px-4 py-3">
                  <select value={r.status} onChange={(e) => advance(r.id, e.target.value)} className="apc-input !py-1.5" data-testid={`onboarding-select-${r.id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="px-4 py-8 text-center text-[#4B5563]">No onboarding records yet.</td></tr>}
          </tbody>
        </table>
      </div>
      <style>{`.apc-input { padding:0.4rem 0.6rem; border-radius:8px; border:1px solid rgba(27,42,65,0.15); background:#fff; font-size:0.85rem; }`}</style>
    </AdminShell>
  );
};

export default AdminOnboarding;
